import BaseModelAPI from '../BaseModelAPI';

export default class WorkOrderExecution extends BaseModelAPI {
	static entity = 'workorderexecution';
	static entityName = 'workorderexecution';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.shiftId = '';
			this.shift = {};
			this.workOrderProcessDetailId = '';
			this.workOrderProcessDetail = {};
			this.billOfProcessDetailId = '';
			this.billOfProcessDetail = {};
			this.subProcessNumber = '';
			this.lotNo = '';
			this.machineId = '';
			this.machine = {};
			this.operatorUserName = '';
			this.operator = {};
			this.machineName = '';
			this.startProduction = '';
			this.finishProduction = '';
			this.qtyPlan = 0;
			this.documentStatusId = '';
			this.documentStatus = {};
			this.workOrderExecutionDetail = []
			this.workOrderExecutionControlTime = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

	static async startProduction(this_, id) {
        return await this_.$http.post(`${this.entityName}/startproduction/${id}`)
            .then(async function(response){
				console.log("response start production", response);
                return response.data;
            })
            .catch(function(error){
                this_.$store.dispatch('addErrorMessageGlobal', error);
                throw error;
            });
    }

	static async finishProduction(this_, id) {
        return await this_.$http.post(`${this.entityName}/finishproduction/${id}`)
            .then(async function(response){
				console.log("response finish production", response);
                return response.data;
            })
            .catch(function(error){
                this_.$store.dispatch('addErrorMessageGlobal', error);
                throw error;
            });
    }
	
	static async productionResult(this_, id) {
        return await this_.$http.post(`${this.entityName}/productionresult/${id}`)
            .then(async function(response){
				console.log("response production result", response);
                return response.data;
            })
            .catch(function(error){
                this_.$store.dispatch('addErrorMessageGlobal', error);
                throw error;
            });
    }

	static async checkLastProcess(this_, id) {
        return await this_.$http.get(`${this.entityName}/checklastprocess/${id}`)
            .then(async function(response){
				console.log("response check last process", response);
                return response.data;
            })
            .catch(function(error){
                this_.$store.dispatch('addErrorMessageGlobal', error);
                throw error;
            });
    }

}